import { render, staticRenderFns } from "./BottomAxis.vue?vue&type=template&id=740654a7&scoped=true"
import script from "./BottomAxis.vue?vue&type=script&lang=js"
export * from "./BottomAxis.vue?vue&type=script&lang=js"
import style0 from "./BottomAxis.vue?vue&type=style&index=0&id=740654a7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "740654a7",
  null
  
)

export default component.exports